import React from 'react';
import * as PropTypes from 'prop-types';
import { Row, Typography } from 'antd';

const { Title } = Typography;


/**
 * Via Header - Main
 * @param credit      credit balance - a number
 * @param children    ant menu element(s)
 */
function ViaHeaderExternal({
  groupCompanyName, logoImageData, logoDataType, groupContactDetails,
}) {
  return (// Ant messages have z-index of 1010 so dont make this any higher than that!
    <div style={{ zIndex: '999' }}>
      <div className="via-header-layout" style={{ marginBottom: '2em' }}>
        <Row className="via-header-view">
          <Row style={{ margin: '1em auto', width: '100vw' }} align="middle" type="flex" justify="space-between">
            <Row type="flex" justify="center" align="middle" style={{ flexWrap: 'nowrap', marginLeft: '1em' }}>
              { logoImageData && logoDataType
                ? (
                  <img src={`data:${logoDataType};base64,${logoImageData}`} className="via-company-logo" alt="" />
                )
                : (
                  <></>)}
              <Title level={3} className="via-header-external-text">{groupCompanyName}</Title>
            </Row>
            {groupContactDetails ? <Row type="flex" justify="end" style={{ whiteSpace: 'nowrap', paddingRight: '1em' }}>{groupContactDetails}</Row> : <div />}
          </Row>
        </Row>
      </div>
    </div>
  );
}

// Validate the prop type parameters.
ViaHeaderExternal.propTypes = {
  groupCompanyName: PropTypes.string,
  logoImageData: PropTypes.string,
  logoDataType: PropTypes.string,
  groupContactDetails: PropTypes.string,
};
ViaHeaderExternal.defaultProps = {
  groupCompanyName: null,
  logoImageData: '',
  logoDataType: '',
  groupContactDetails: null,
};

export default ViaHeaderExternal;
